// extracted by mini-css-extract-plugin
export var gap_200 = "c_l";
export var icon = "c_n";
export var prevSection = "c_m";
export var section = "c_j";
export var separator = "c_k";
export var statePrivacy = "c_g";
export var table = "c_h";